<div class="overlay">
    <mds-spinner
        color="primary"
        class="c-spinnerOverlay_positionFixed"
        mode="indeterminate"
        [diameter]="200"
        [strokeWidth]="6"
    ></mds-spinner>
</div>
